import { $http } from "@/utils/https";
import type { ActionContext } from "vuex";
import type { RootState } from "@/store";

interface State {
  allProductsFeedbacksProfessional: any;
  allProductsFeedbacks: any;
  content: any,
  filters: any,
  products: any
}

const state: State = {
  allProductsFeedbacksProfessional: null,
  allProductsFeedbacks: null,
  content: null,
  filters: null,
  products: null
};

const getters = {
  allProductsFeedbacksProfessional: (state: State) => state.allProductsFeedbacksProfessional,
  allProductsFeedbacks: (state: State) => state.allProductsFeedbacks,
  content: (state: State) => state.content,
  filters: (state: State) => state.filters,
  products: (state: State) => state.products
};

const actions = {
  FETCH_FILTERS: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      let url = "v1/catalog/filters"
      const response = await $http.get(url);
      commit("SET_FILTERS", response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  LEAVE_FEEDBACK: async ({ commit }: ActionContext<State, RootState>, payload: any) => {
    try {
      let url = "v1/products/feedbacks"
      const response = await $http.post(url, payload);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  FETCH_FEEDBACKS_PAGE: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      let url = "v1/pages/cosmetics-reviews"
      const response = await $http.get(url);
      commit("SET_CONTENT", response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  FETCH_ALL_PRODUCTS_FEEDBACKS_PROFESSIONAL: async ({ commit }: ActionContext<State, RootState>, payload: any) => {
    try {
      let url = "v1/all_product_feedbacks"
      const response = await $http.get(url, {params: {...payload, is_professional: 1}});
      commit("SET_ALL_PRODUCTS_FEEDBACKS_PROFESSIONAL", response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  FETCH_ALL_PRODUCTS_FEEDBACKS: async ({ commit }: ActionContext<State, RootState>, payload: any) => {
    try {
      let url = "v1/all_product_feedbacks"
      const response = await $http.get(url, {params: {...payload, is_professional: 0}});
      commit("SET_ALL_PRODUCTS_FEEDBACKS", response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  FETCH_PRODUCTS: async ({ commit }: ActionContext<State, RootState>, payload: any) => {
    try {
      let url = "v1/catalog/products"
      const response = await $http.get(url, {params: {...payload}});
      commit("SET_PRODUCTS", response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  SET_ALL_PRODUCTS_FEEDBACKS_PROFESSIONAL(state: State, payload: any) {
    state.allProductsFeedbacksProfessional = payload;
  },
  SET_ALL_PRODUCTS_FEEDBACKS(state: State, payload: any) {
    state.allProductsFeedbacks = payload;
  },
  SET_CONTENT(state: State, payload: any) {
    state.content = payload;
  },
  SET_PRODUCTS(state: State, payload: any) {
    state.products = payload;
  },
  SET_FILTERS(state: State, payload: any) {
    state.filters = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
